import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';

const InvitationListModel = t.model('InvitationListModel', {
  email: t.string,
  merchantID: t.string,
  mid: t.string,
  role: t.string,
  createdAt: t.string,
  expiredAt: t.string,
  status: t.string,
  phone: t.maybeNull(t.string),
});

const InvitationModel = t
  .model('InvitationModel', {
    list: t.array(InvitationListModel),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default InvitationModel;
